const messages = {
  en: {
    importarProductos: {
      menuTitle: "Import products",
      title: "Import products",
      step1: "Initial configuration",
      step2: "File and mapping",
      step3: "Prices, codes & review",
      step4: "Confirm",
      proveedor: "Supplier",
      deposito: "Warehouse",
      tipoSimple: "Simple (name only)",
      tipoEstructurado: "Structured (brand, model, size)",
      selectProveedor: "Supplier",
      newProveedor: "New supplier",
      agregarProveedor: "Add supplier",
      newProveedorTitle: "Quick add supplier",
      createProveedor: "Create",
      createProveedorAndUse: "Create and use",
      cancel: "Cancel",
      selectDeposito: "Warehouse",
      selectFile: "CSV/Excel file",
      downloadTemplateSimple: "Simple Template",
      downloadTemplateStructured: "Structured Template",
      continue: "Continue",
      back: "Back",
      confirm: "Confirm and import",
      success: "Products imported successfully",
      error: "Error importing products",
      aplicados: "Applied to all",
      precioVenta: "Sale price",
      precioCompra: "Purchase price",
      producto: "Product",
      marca: "Brand",
      modelo: "Model",
      tamanio: "Size",
      existe: "Exists",
      nuevo: "New",
      hintArchivoSimple:
        "Same columns as supplier price list (simple): supplier code (codigo_proveedor), name, purchase price, supplier discount (%). Own barcode is not read from the file; it is set in the review step or auto-generated.",
      hintArchivoEstructurado:
        "Same columns as supplier price list (structured): supplier code (codigo_proveedor), brand, model, size column (e.g. tamaño, tamanio, size), other attributes, purchase price, supplier discount (%). Own barcode is not in the template.",
      hintPasoPreciosYRevision:
        "Set purchase and sale prices, supplier discount, VAT and margin. Review supplier code, own-barcode strategy and per-row code. In structured mode you can adjust brand, model and size; warnings show when new master data will be created.",
      codigoDelProveedor: "Supplier code",
      codigoPropio: "Own barcode",
      estrategiaCodigoBarras: "Strategy for own barcode",
      productosAImportar: "Products to import",
      advertenciaCorta: "Warn",
      verDetalleErrores: "Show row error details",
      verDetalleAvisos: "Show row warning details",
      // Mapping wizard
      allFieldsMapped: "All fields mapped. You can continue.",
      columnAlreadyMapped: "This column is already assigned to another field.",
      errorSeleccion: "Select a file before continuing.",
      errorPrecioRequired: "Purchase price column is required.",
      errorIdentificadorRequired: "At least name or supplier code must be mapped.",
      errorIdentificadorEstructurado: "At least brand, model or size must be mapped.",
      errorFilasVacias: "No valid rows with purchase price found.",
      errorProcesar: "Error processing the file.",
      fieldCodigoBarrasProveedor: "Supplier code",
      fieldNombre: "Name",
      fieldPrecioCompra: "Purchase price",
      fieldDescuentoProveedor: "Discount %",
      fieldMarca: "Brand",
      fieldModelo: "Model",
      fieldTamanio: "Size",
      fieldOtrasCaracteristicas: "Other attributes",
    },
  },
  es: {
    importarProductos: {
      menuTitle: "Importar productos",
      title: "Importar productos",
      step1: "Configuración inicial",
      step2: "Archivo y mapeo",
      step3: "Precios, códigos y revisión",
      step4: "Confirmar",
      proveedor: "Proveedor",
      deposito: "Depósito",
      tipoSimple: "Simple (solo nombre)",
      tipoEstructurado: "Estructurado (marca, modelo, tamaño)",
      selectProveedor: "Proveedor",
      newProveedor: "Nuevo proveedor",
      agregarProveedor: "Agregar proveedor",
      newProveedorTitle: "Cargar proveedor rápido",
      createProveedor: "Crear",
      createProveedorAndUse: "Crear y usar",
      cancel: "Cancelar",
      selectDeposito: "Depósito",
      selectFile: "Archivo CSV/Excel",
      downloadTemplateSimple: "Plantilla Simple",
      downloadTemplateStructured: "Plantilla Estructurada",
      continue: "Continuar",
      back: "Volver",
      confirm: "Confirmar e importar",
      success: "Productos importados correctamente",
      error: "Error al importar productos",
      aplicados: "Aplicados a todos",
      precioVenta: "Precio venta",
      precioCompra: "Precio compra",
      producto: "Producto",
      marca: "Marca",
      modelo: "Modelo",
      tamanio: "tamaño",
      existe: "Existe",
      nuevo: "Nuevo",
      hintArchivoSimple:
        "Mismas columnas que la lista de precios del proveedor (simple): código del proveedor (codigo_proveedor), nombre, precio de compra, descuento del proveedor (%). El código de barras propio no va en el archivo; se configura en el paso siguiente o se autogenera.",
      hintArchivoEstructurado:
        "Mismas columnas que la lista de precios del proveedor (estructurado): código del proveedor (codigo_proveedor), marca, modelo, columna tamaño, otras características, precio de compra, descuento del proveedor (%). Sin columna código de barras propio en la plantilla.",
      hintPasoPreciosYRevision:
        "En modo estructurado puede ajustar marca, modelo y tamaño; los avisos indican si se crearán valores nuevos en el sistema.",
      codigoDelProveedor: "Código del proveedor",
      codigoPropio: "Código propio",
      estrategiaCodigoBarras: "Estrategia para generar código de barras propio",
      productosAImportar: "Productos a importar",
      advertenciaCorta: "Aviso",
      verDetalleErrores: "Ver detalle de errores de la fila",
      verDetalleAvisos: "Ver detalle de avisos de la fila",
      // Mapping wizard
      allFieldsMapped: "Todos los campos mapeados. Podés continuar.",
      columnAlreadyMapped: "Esta columna ya está asignada a otro campo.",
      errorSeleccion: "Seleccioná un archivo antes de continuar.",
      errorPrecioRequired: "La columna de precio de compra es requerida.",
      errorIdentificadorRequired: "Al menos nombre o código del proveedor deben estar mapeados.",
      errorIdentificadorEstructurado: "Al menos marca, modelo o tamaño deben estar mapeados.",
      errorFilasVacias: "No se encontraron filas con precio de compra válido.",
      errorProcesar: "Error al procesar el archivo.",
      fieldCodigoBarrasProveedor: "Código del proveedor",
      fieldNombre: "Nombre",
      fieldPrecioCompra: "Precio compra",
      fieldDescuentoProveedor: "Descuento %",
      fieldMarca: "Marca",
      fieldModelo: "Modelo",
      fieldTamanio: "Tamaño",
      fieldOtrasCaracteristicas: "Otras características",
    },
  },
  pt: {
    importarProductos: {
      menuTitle: "Importar produtos",
      title: "Importar produtos",
      step1: "Configuração inicial",
      step2: "Arquivo e mapeamento",
      step3: "Preços, códigos e revisão",
      step4: "Confirmar",
      proveedor: "Fornecedor",
      deposito: "Depósito",
      tipoSimple: "Simples (somente nome)",
      tipoEstructurado: "Estruturado (marca, modelo, tamanho)",
      selectProveedor: "Fornecedor",
      newProveedor: "Novo fornecedor",
      agregarProveedor: "Adicionar fornecedor",
      newProveedorTitle: "Adicionar fornecedor rápido",
      createProveedor: "Criar",
      createProveedorAndUse: "Criar e usar",
      cancel: "Cancelar",
      selectDeposito: "Depósito",
      selectFile: "Arquivo CSV/Excel",
      downloadTemplateSimple: "Modelo Simples",
      downloadTemplateStructured: "Modelo Estruturado",
      continue: "Continuar",
      back: "Voltar",
      confirm: "Confirmar e importar",
      success: "Produtos importados com sucesso",
      error: "Erro ao importar produtos",
      aplicados: "Aplicados a todos",
      precioVenta: "Preço de venda",
      precioCompra: "Preço de compra",
      producto: "Produto",
      marca: "Marca",
      modelo: "Modelo",
      tamanio: "tamanho",
      existe: "Existe",
      nuevo: "Novo",
      hintArchivoSimple:
        "Mesmas colunas que a lista de preços do fornecedor (simples): código do fornecedor (codigo_proveedor), nome, preço de compra, desconto do fornecedor (%). O código de barras próprio não está no arquivo; configura-se no passo seguinte ou é autogerado.",
      hintArchivoEstructurado:
        "Mesmas colunas que a lista de preços do fornecedor (estruturado): código do fornecedor (codigo_proveedor), marca, modelo, coluna tamanho, outras características, preço de compra, desconto do fornecedor (%). Sem coluna de código de barras próprio na planilha modelo.",
      hintPasoPreciosYRevision:
        "Defina preços de compra e venda, desconto do fornecedor, IVA e margem. Ajuste o código do fornecedor, a estratégia do código próprio e o código por linha. No modo estruturado pode editar marca, modelo e tamanho; os avisos indicam se serão criados valores novos.",
      codigoDelProveedor: "Código do fornecedor",
      codigoPropio: "Código próprio",
      estrategiaCodigoBarras: "Estratégia para código de barras próprio",
      productosAImportar: "Produtos a importar",
      advertenciaCorta: "Aviso",
      verDetalleErrores: "Ver detalhes dos erros da linha",
      verDetalleAvisos: "Ver detalhes dos avisos da linha",
      // Mapping wizard
      allFieldsMapped: "Todos os campos mapeados. Pode continuar.",
      columnAlreadyMapped: "Esta coluna já está atribuída a outro campo.",
      errorSeleccion: "Selecione um arquivo antes de continuar.",
      errorPrecioRequired: "A coluna de preço de compra é obrigatória.",
      errorIdentificadorRequired: "Pelo menos nome ou código do fornecedor devem ser mapeados.",
      errorIdentificadorEstructurado: "Pelo menos marca, modelo ou tamanho devem ser mapeados.",
      errorFilasVacias: "Nenhuma linha com preço de compra válido encontrada.",
      errorProcesar: "Erro ao processar o arquivo.",
      fieldCodigoBarrasProveedor: "Código do fornecedor",
      fieldNombre: "Nome",
      fieldPrecioCompra: "Preço de compra",
      fieldDescuentoProveedor: "Desconto %",
      fieldMarca: "Marca",
      fieldModelo: "Modelo",
      fieldTamanio: "Tamanho",
      fieldOtrasCaracteristicas: "Outras características",
    },
  },
};

export default messages;
